var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getGoverningPump } from "ui/components/panels/graphs/common/helper-functions";
export var errors;
(function (errors) {
    errors["NO_CUP_DATA"] = "no suction cup data available";
    errors["NO_PUMP_DATA"] = "no vacuum pump data available";
})(errors || (errors = {}));
/* A time_2_ps of 0 means the component never reached the part secured level.
 * The pumps may reach PS even when the cups never do (e.g. when severely
 * restricted tubing chokes the flow), so the system has only reached part
 * secured when every pump AND every suction cup has reached it. */
var hasSystemReachedPartSecured = function (response) {
    return __spreadArray(__spreadArray([], __read(response.vacuum_pumps), false), __read(response.suction_cups), false).every(function (component) { return component.time_2_ps > 0; });
};
export var deserializeResponseToSystemPerformance = function (response, apiIdToNodeId) {
    var system_property = response.system_property, suction_cups = response.suction_cups, vacuum_pumps = response.vacuum_pumps, sanity_check = response.sanity_check;
    var nodeData = {};
    if (vacuum_pumps.length === 0) {
        throw Error(errors.NO_PUMP_DATA);
    }
    suction_cups.forEach(function (cup) {
        var nodeId = apiIdToNodeId[cup.id];
        var data = {
            timeToPartSecured: cup.time_2_ps,
            timeToEnergySave: cup.time_2_es,
            finalVacuumLevel: cup.final_vac_level,
            connectedPumpId: cup.pump_connection_id,
            vacuumLevels: cup.vacuum_level,
            vacuumLevelAtSystemPS: cup.vacuum_level_at_system_ps,
            vacuumLevelAtSystemES: cup.vacuum_level_at_system_es,
            liftingForceHorizontalAtPS: cup.lifting_force_horizontal_at_system_ps,
            liftingForceVerticalAtPS: cup.lifting_force_vertical_at_system_ps,
            liftingForceHorizontalAtES: cup.lifting_force_horizontal_at_system_es,
            liftingForceVerticalAtES: cup.lifting_force_vertical_at_system_es,
            liftingForceHorizontal: cup.lifting_force_horizontal,
            liftingForceVertical: cup.lifting_force_vertical,
        };
        if (nodeData[nodeId]) {
            nodeData[nodeId].suctionCup = data;
        }
        else {
            nodeData[nodeId] = { suctionCup: data };
        }
    });
    vacuum_pumps.forEach(function (pump) {
        var nodeId = apiIdToNodeId[pump.id];
        var data = {
            id: pump.id,
            timeToPartSecured: pump.time_2_ps,
            timeToEnergySave: pump.time_2_es,
            finalVacuumLevel: pump.final_vac_level,
            vacuumLevels: pump.vacuum_level,
            compressedAirPressure: pump.compressed_air_pressure,
            freeRunningVacuumLevel: pump.free_running_vacuum_level,
            feedPressureRecommended: pump.feed_pressure_recommended,
            airConsumptionTotal: pump.airconsumption_total,
        };
        if (nodeData[nodeId]) {
            nodeData[nodeId].vacuumPump = data;
        }
        else {
            nodeData[nodeId] = { vacuumPump: data };
        }
    });
    var systemReachedPs = hasSystemReachedPartSecured(response);
    var systemTimeToPs = systemReachedPs
        ? Math.max.apply(Math, __spreadArray([], __read(vacuum_pumps.map(function (pump) { return pump.time_2_ps; })), false)) : 0;
    var systemTimeToEs = Math.max.apply(Math, __spreadArray([], __read(vacuum_pumps.map(function (pump) { return pump.time_2_es; })), false));
    return {
        nodeData: nodeData,
        vacuumLevelTimeData: system_property.time_data,
        systemTimeToPartSecured: systemTimeToPs,
        systemTimeToEnergySave: systemTimeToEs,
        compressedAirFlowrateVac: system_property.compressed_air_flowrate_vac,
        compressedAirFlowrateBlowOff: system_property.compressed_air_flowrate_BO,
        airConsumptionTotal: system_property.airconsumption_total,
        airConsumptionVacuumGeneration: system_property.airconsumption_vacuum_generation,
        airConsumptionBlowOff: system_property.airconsumption_blow_off,
        transferTimeWithPart: system_property.transfer_time_with_part,
        blowOffTimeToAtm: system_property.blow_off_time_to_atm,
        transferTimeReturn: system_property.transfer_time_return,
        totalHorizontalLiftForceAtPS: system_property === null || system_property === void 0 ? void 0 : system_property.lifting_force_horizontal_at_system_ps,
        totalVerticalLiftForceAtPS: system_property === null || system_property === void 0 ? void 0 : system_property.lifting_force_vertical_at_system_ps,
        systemModel: system_property.system_model,
        energyUsageTotal: system_property.energy_use_total,
        energyUsageVacuumGeneration: system_property.energy_use_vacuum_generation,
        energyUsageBO: system_property.energy_use_BO,
        energyUsage8hr: system_property.energy_use_8hr,
        averageCompressorPower: system_property.compressor_average_power,
        // Graph data
        airConsumptionVsTime: system_property.air_cons_vs_time,
        robotMotionVsTime: system_property.robot_motion_vs_time,
        /* The API's ps_index marks where the pumps reached PS. If the cups never
         * reached PS, the part was never secured, so invalidate the index to keep
         * the graphs from drawing part secured markers (mirrors es_index = -1). */
        psIndex: systemReachedPs ? system_property.ps_index : -1,
        esIndex: system_property.es_index,
        placeStopIndex: system_property.place_stop_index,
        placeStartIndex: system_property.place_start_index,
        governingPump: getGoverningPump(nodeData, sanity_check.governing_pump_id),
        liftingForceHorizontalVsTime: system_property === null || system_property === void 0 ? void 0 : system_property.lifting_force_horizontal,
        liftingForceVerticalVsTime: system_property === null || system_property === void 0 ? void 0 : system_property.lifting_force_vertical,
    };
};
export var deserializeResponseToSystemSanityCheck = function (response, includeEnergySave) {
    var sanity_check = response.sanity_check;
    return {
        estimatedCalculationTime: sanity_check.calculation_time_estimate,
        freeRunningVacuumLevel: sanity_check.free_running_vacuum_level,
        freeRunningVacuumLevelMessage: sanity_check.free_running_vacuum_level_quality,
        feedPressureMessage: sanity_check.feed_pressure_quality,
        energySaveAvailable: includeEnergySave,
        energySaveReachable: includeEnergySave
            ? sanity_check.energy_saving_reachable
            : undefined,
        /* The API's part_secured_reachable only considers the pumps, so it can
         * report true even when the cups never reach the part secured level. */
        partSecuredReachable: sanity_check.part_secured_reachable &&
            hasSystemReachedPartSecured(response),
        estimatedTimeToEnergySave: includeEnergySave
            ? sanity_check.time_to_energy_saving
            : undefined,
        estimatedTimeToPartSecured: sanity_check.time_to_part_secured,
        cycleTimeReachable: sanity_check.cycle_time_reachable,
        validationPassed: sanity_check.sanity_check_passed,
        governingPumpId: sanity_check.governing_pump_id,
        feedPressureActual: sanity_check.feed_pressure_actual,
        feedPressureRecommended: sanity_check.feed_pressure_recommended,
        feedPressureDrop: sanity_check.feed_pressure_drop,
        feedPressureDropQuality: sanity_check.feed_pressure_drop_quality,
        feedPressureRangeMax: sanity_check.feed_pressure_range_max,
        feedPressureRangeMin: sanity_check.feed_pressure_range_min,
    };
};
